export default __webpack_public_path__ + "static/media/player_1.c00bf026.png";